import { Outlet } from "react-router-dom";

export default function Legal() {
    return (
        <main role="main">
            <Outlet />
        </main>
    );
}